import { Box, Chip, Stack, Tooltip, Typography } from "@mui/material";
import React from "react";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { checkForEmptyNotes } from "../../helper/helpersSubModule";
import { styled } from "@mui/material/styles";
import { isStringifiedArrayWithPropName } from "../../../../helpers/ExportHelper"; 
import { applyStylestoCellRenderer } from "../../helper/helperFunctions";
import "./MultiDimensionalColumnRenderer.css";
import MdvTooltipContent from "./MdvTooltipContent";
import PropTypes from 'prop-types';


const ArrowIcon = styled(ArrowDropDownIcon)`
  position: absolute;
  top: 2px;
  right: 22px;
  color: #3fd237;
  font-size: 28px;
  transform: rotate(225deg);
  transform-origin: top right;
`;

const FushionCustomColumn = ({ params, type, readOnlyMode}) => {
  let { node, column, eGridCell, colDef, data } = params;
  let value = params?.value ? params?.value : [];
  if (value && typeof value === "string" && isStringifiedArrayWithPropName(value)) {
    try{
      value = JSON.parse(value);
    }catch(e){
      value = []
    }
  }else{
    value = []
  }

  let columnName = colDef.field + "_es";
  let cellFormatting = data ? data[columnName]?.cellStyle : {};
  let cellFormat = data ? data[columnName]?.format : '';
  const cellStyles = applyStylestoCellRenderer(cellFormat);


  const getInitials = (name) => {
    return name
      .split(" ")
      .map((word) => word.charAt(0)?.toUpperCase())
      .join("");
  };

  const truncateValue = (value) => {
    if (Array.isArray(value)) {
        value = value.join(', ');
    }
    
    return typeof value === 'string' && value.length > 10 
        ? value.substring(0, 10) + '...' 
        : value;
};

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        paddingY: "0rem",
        flexWrap: "wrap",
        width: "100%",
        height: value ? "fit-content" : eGridCell.clientHeight - 4 + "px",
      }}
    >
      <Stack
        direction="row"
        className="containerWrap"
        style={{backgroundColor:cellFormatting?.backgroundColor || "transparent", 
        padding : "2px",
      }}
      >
        {Array.isArray(value) &&
          value.map((item) => {
            if (item.propValue !== "") {
              let propertyName = getInitials(item.propName);
              let propertyValue = truncateValue(item.propValue);
              let formattedValue = "";
              if (typeof item.propValue === "string" && !isNaN(item.propValue)) {
                const numberValue = parseFloat(item.propValue);
                const hours = Math.floor(numberValue);
                const decimalPart = item.propValue.split('.')[1] || '0';
                const minutes = parseInt(decimalPart)
                formattedValue = `${hours.toString().padStart(2, '0')}:${minutes < 10 ? '0' + minutes : minutes}`;
              }
              return (
                <Tooltip
                key={`${item.propAbbrevation} : ${propertyValue}`}
                  title={type !== 'card' && <MdvTooltipContent value={value} colDef={params.colDef} />}
                >
                {propertyValue && (
                  <Chip
                    label={
                      <Typography
                        component="span"
                        variant="body2"
                        style={{
                          ...cellStyles,
                          fontSize: cellFormatting?.fontSize || "10px",
                          color: `${item.propFgColor ? item.propFgColor : "black"} !important`,
                          fontFamily: cellFormatting?.fontFamily || "Arial",
                        }}
                      >
                        <Typography
                          component="span"
                          style={{
                            ...cellStyles,
                            fontWeight: "bold",
                            fontSize: cellFormatting?.fontSize || "10px",
                            color: `${item.propFgColor ? item.propFgColor : "black"} !important`,
                            fontFamily: cellFormatting?.fontFamily || "Arial",
                          }}
                        >
                          {`${item.propAbbrevation?.toUpperCase()} : `}
                        </Typography>
                        {params.colDef.block === "timeseries" &&
                        (item.propAbbrevation === 'PT' || item.propAbbrevation === 'AT' || item.propAbbrevation === 'WH')
                          ? formattedValue
                          : propertyValue}
                      </Typography>
                    }
                    size="small"
                    sx={{
                      background: item.propAbbrevation === 'TE'
                        ? "#FFB6C1 !important"
                        : `${item.propBgColor && item.propBgColor !== "none" ? item.propBgColor : "transparent"}`,
                      fontSize: "11px",
                      color: `${item.propFgColor ? item.propFgColor : "black"} !important`,
                      fontFamily: "Arial",
                      border: "2px solid #bdbdbd",
                      borderLeft: `2px solid #6adc99`,
                      borderRight: `2px solid #6adc99`,
                      borderRadius: "1rem",
                      height: "12px",
                      padding: "6px 0px",
                    }}
                  />
                )}
              </Tooltip>
              
              
              );
            }
            return null;
          })}
      </Stack>
      {params?.colDef?.field && params?.data?.hasOwnProperty(params?.colDef?.field+'_es') && params?.data[params?.colDef?.field + "_es"]!==undefined && !checkForEmptyNotes(params?.data[params.colDef.field + "_es"]?.notes) &&
           <ArrowIcon onClick={(e) => { if(!readOnlyMode){params.onClickOpenRightDrawer("notes", 0); }}} />
      }
    </Box>
  );
};
FushionCustomColumn.propTypes = {
  params: PropTypes.shape({
      node: PropTypes.object,
      column: PropTypes.object,
      eGridCell: PropTypes.object,
      colDef: PropTypes.object,
      data: PropTypes.object,
      onClickOpenRightDrawer: PropTypes.func,
  }).isRequired,
  type: PropTypes.string,
  readOnlyMode: PropTypes.bool,
  onClickOpenRightDrawer:PropTypes.func
};
export default FushionCustomColumn;